import { LeakOffIcon } from './LeakOffIcon';

/**
 * author: Google
 * id EDA0BABB-A354-481B-8E60-108E3B20D64C
 * name leak-off
 * version: 3.5.94
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/leak-off.svg
 * tags
 */
export const ProximitySensorOffIcon = LeakOffIcon;
export default ProximitySensorOffIcon